export default [{
  path: '/certificados',
  component: {
    name: 'certificados',
    template: '<router-view />',
    meta: {
      resource: 'certificado',
      action: 'read',
      breadcrumb: [
        { text: '', to: { path: '/' } },
      ],
    },
  },
  children: [{
    path: 'visualizar',
    name: 'certificados',
    component: () => import('@/app-modulo/comuns/certificado/certificadoView.vue'),
    meta: {
      resource: 'certificado',
      action: 'read',
      navActiveLink: 'certificados',
      pageTitle: 'Cadastro de certificados',
      breadcrumb: [
        {
          text: 'Certificados',
          to: { name: 'certificados' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'novo',
    name: 'novo-certficado',
    component: () => import('@/app-modulo/comuns/certificado/shared/components/cadastro/Certificado.vue'),
    meta: {
      resource: 'certificado',
      action: 'create',
      navActiveLink: 'certificados',
      pageTitle: 'Cadastro de certificados',
      breadcrumb: [
        {
          text: 'Certificados',
          to: { name: 'certificados' },
        },
        {
          text: 'Novo',
          to: { name: 'novo-certficado' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar/:id',
    name: 'editar-certificado',
    component: () => import('@/app-modulo/comuns/certificado/shared/components/cadastro/Certificado.vue'),
    meta: {
      resource: 'certificado',
      action: 'update',
      navActiveLink: 'certificados',
      pageTitle: 'Cadastro de certificados',
      breadcrumb: [
        {
          text: 'Certificados',
          to: { name: 'certificados' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-certificado' },
          active: true,
        },
      ],
    },
  },
  {
    path: 'editar-observacao/:id',
    name: 'editar-observacao',
    component: () => import('@/app-modulo/comuns/certificado/shared/components/cadastro/Certificado.vue'),
    meta: {
      resource: 'certificado',
      action: 'read',
      navActiveLink: 'certificados',
      pageTitle: 'Cadastro de certificados',
      breadcrumb: [
        {
          text: 'Certificados',
          to: { name: 'certificados' },
        },
        {
          text: 'Editar',
          to: { name: 'editar-observacao' },
          active: true,
        },
      ],
    },
  }],
}]
